import { render, staticRenderFns } from "./ProductDropdownRightPanel.vue?vue&type=template&id=c4d9db68&scoped=true"
import script from "./ProductDropdownRightPanel.vue?vue&type=script&lang=js"
export * from "./ProductDropdownRightPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductDropdownRightPanel.vue?vue&type=style&index=0&id=c4d9db68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d9db68",
  null
  
)

export default component.exports